import { useCallback } from 'react';
import { InAppBrowser } from '@capgo/inappbrowser';
import { openWindow } from 'commons/utils/window';
import { useIsMobileDevice } from 'domains/Auth/hooks';

/**
 * Hook to open a URL in an in-app browser if the user is on a mobile device.
 * If the user is not on a mobile device, the URL will be opened in a new window.
 */
export function useInAppBrowser() {
  const isMobileDevice = useIsMobileDevice();

  const openInAppBrowser = useCallback(
    async (url: string) => {
      if (isMobileDevice) {
        const inAppBrowser = await InAppBrowser.open({
          url,
        });

        inAppBrowser.executeScript({
          code: `
            window.addEventListener('beforeunload', function() {
                sessionStorage.removeItem('is_in_app_browser');
            });
        `,
        });
      } else {
        openWindow(url, false);
      }
    },
    [isMobileDevice],
  );

  return openInAppBrowser;
}
